import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

import { Tipografia } from "../../../../_common";

TimelineItemEventoCustomWhatsapp.propTypes = {
  eventoCustom: PropTypes.object,
};

function TimelineItemEventoCustomWhatsapp({ eventoCustom }) {
  const intl = useIntl();

  return (
    <Tipografia>
      {!eventoCustom.leadAntigo
        ? intl.formatMessage(
            {
              defaultMessage: `O histórico do chat do WhatsApp foi recebido do Lead {linkLead}`,
            },
            {
              linkLead: <a href={`/spotter/detalhes-lead/${eventoCustom.leadId}`}>{eventoCustom.nomeLead}</a>,
            }
          )
        : intl.formatMessage(
            {
              defaultMessage: `O histórico do chat do WhatsApp foi transferido para o Lead {linkLead}`,
            },
            {
              linkLead: <a href={`/spotter/detalhes-lead/${eventoCustom.leadId}`}>{eventoCustom.nomeLead}</a>,
            }
          )}
    </Tipografia>
  );
}

export default TimelineItemEventoCustomWhatsapp;
